/*
 * @Author       : a大师兄
 * @Date         : 2021-07-28 15:49:56
 * @LastEditors  : a大师兄
 * @LastEditTime : 2021-08-03 16:18:17
 * @Description  :app路由
 */

import Vue from 'vue';
import {
  getOpenIdUtil
} from '@/utils/js/wxRedirect.js';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

const routes = [{
  path: '/',
  name: 'index',
  redirect: '/productlist',
  meta: {
    client: 'wx',
    wx: {
      isShare: false
    },
  },
},
{
  path: '/productlist',
  name: 'ProductList',
  meta: {
    index: 0,
    title: '产品列表',
    client: 'wx',
    wx: {
      isShare: false
    },
  },
  component: () => import('@/views/proposal/views/productlist/ProductList'),
},
{
  path: "*",
  redirect: "/404"
},
{
  path: '/404',
  name: 'Page_404',
  meta: {
    title: '页面没有找到',
  },
  component: () =>
    import('@com/products/exception_pages/404.vue'),
},
];

let router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  //获取openId
  getOpenIdUtil(to, from, next)
  next()
})

export default router;